export default {"src":"/_next/static/media/CarbonScheme.7fc1a99f.svg","height":45,"width":45,"blurWidth":0,"blurHeight":0};